/**
 * Which datasets the map shows. `?dataset=<id>` is the primary one (the camera fits to it);
 * `?layers=<id>,<id>` stacks more on top of it (Insert > Open > Add).
 */

/** Dataset ids named by the URL: `dataset` first, then `layers`, de-duplicated. */
export function datasetIdsFromParams(searchParams) {
  const ids = [];
  const push = (v) => { const id = String(v || '').trim(); if (id && !ids.includes(id)) ids.push(id); };
  push(searchParams.get('dataset'));
  String(searchParams.get('layers') || '').split(',').forEach(push);
  return ids;
}

/** The `?layers=` ids only (what Add put there), without the primary dataset. */
export function extraLayerIds(searchParams) {
  const primary = searchParams.get('dataset');
  return datasetIdsFromParams(searchParams).filter((id) => id !== primary);
}

/** A copy of the params with `id` added to `layers` (no-op when it is already shown). */
export function addLayerParam(searchParams, id) {
  const next = new URLSearchParams(searchParams);
  if (datasetIdsFromParams(next).includes(id)) return next;
  next.set('layers', [...String(next.get('layers') || '').split(',').filter(Boolean), id].join(','));
  return next;
}

/** A copy of the params with `id` dropped from `layers` (the param goes when it empties). */
export function removeLayerParam(searchParams, id) {
  const next = new URLSearchParams(searchParams);
  const left = String(next.get('layers') || '').split(',').filter((x) => x && x !== id);
  if (left.length) next.set('layers', left.join(',')); else next.delete('layers');
  return next;
}
